import { Booking } from '../Types';
import { AddCreditData } from '../Types/ServiceTypes';
import requestClient from '../components/Utility/RequestClient';

export const creditService = {
    addCredit: async (data: AddCreditData): Promise<any> => {
        return requestClient.post(`/billing/addcredit`, data);
    },

    getBooking: async (): Promise<{ data: { data: Booking[]; total: number } }> => {
        return requestClient.get(`/billing/bookings`);
    },
};
